import React, { useEffect, useState } from 'react';
import '../assets/css/material-dashboard.css';
import './criarordemmodal.css';
import HomeLf from './HomeLf';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import Background from 'three/examples/jsm/renderers/common/Background.js';
import { Center } from '@react-three/drei';

import logo from '../assets/version2/logo.png'
import listicon from '../assets/version2/listicon.png';
import gridicon from '../assets/version2/gridicon.png';
import Rodape from './Rodape';

function Relatorio(params) {

  const navigate = useNavigate();


  const [current, setCurrent] = useState('');
  const [dataA, setDataA] = useState([]);
  const [filtrados, setFiltrados] = useState([]);
  const [filtradosB, setFiltradosB] = useState([]);
  const [objetoTarget, setObjetoTarget] = useState();
  const [dataId, setDataId] = useState();
  const [nomeproj, setNomeproj] = useState('');

  const [dataMaster, setDataMaster] = useState([]);


    const [mapeA, setMapeA] = useState([1]);
    const [hide, setHide] = useState('flex');
    const [hide2, setHide2] = useState('none');



  const [requisitante, setRequisitante] = useState([]);
  const [responsavel, setResponsavel] = useState([]);





var count01 = 0;
const queryParameters = new URLSearchParams(window.location.search);
const parametroId = queryParameters.get("prjid");


const [countMp, setCountMp] = useState(1);

const [dataPendencias, setDataPendencias] = useState([]);

const [solucao, setSolucao] = useState([]);





async function master(params) {

      

  var objMaster = [];
  var objMaster2 = [];

   


  onAuthStateChanged(firebaseAuth, async (currentUser) => {
    if (currentUser) {
      var usuarioLogado = currentUser.email;
      setCurrent(usuarioLogado);



      await fetch('https://apilumera.shop/api/consultarelatorio', {
        method: 'POST',
        body: JSON.stringify({
          email: usuarioLogado,
    
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
         .then((response) => response.json())
         .then((data) => {
    
          setDataA(data);
          setFiltrados(data);
          console.log('DATA', data);
      
          
          var colaborador = [];
          for (let i = 0; i < data.length; i++) {
            if(data[i].colaboradores.length > 0){
                colaborador.push(data[i].colaboradores);
            }
          }
                 // console.log('colaborador', colaborador);
                 var tradeRemove = [];
                  var tradeRemove2 = [];
                 for (let i = 0; i < colaborador.length; i++) {
                
                  tradeRemove.push(colaborador[i][0]);
                  
                 }
                  
                 
             function removeDuplicatesWithSet2(arr) {
                 return [...new Set(arr)];
             }

           var uniqueArray2 = removeDuplicatesWithSet2(tradeRemove);

          

           for (let i = 0; i < uniqueArray2.length; i++) {
                       tradeRemove2.push([uniqueArray2[i]])
           }


         setSolucao(tradeRemove2);








         })
         .catch((err) => {
            console.log(err.message);
         });
    












    };
  });




  //consultarelatorio



























































        



}


async function editar(params) {
  navigate(`/editar?projeto=${params}`);
}





async function dell(params) {


  await updateDoc(doc(db, 'clientes', `${firebaseAuth.currentUser.email}:projetos`), {
    [params]: {
        nomeDoProjeto: 'nd',
      

    }
  
  });
  navigate(0);
}


































































       function limparFiltros() {
          window.location.reload();
       }













useEffect(()=> {
  master();
},[])











function enviarPost01() {


  function getObj(params) {

    for (let i = 0; i < dataMaster.length; i++) {
        if(dataMaster[i].split('###master')[3].replaceAll(' ', '') == params.replaceAll(' ', '')){
          return dataMaster[i];
        }
    }
}



var tradecolaboradores = [];
for (let i = 0; i < document.querySelectorAll('.colaboradores').length; i++) {
    tradecolaboradores.push(getObj(document.querySelectorAll('.colaboradores')[i].value.replaceAll(' ', '')))
  
}
  
  console.log('tradecolaboradores ',tradecolaboradores);

  var emailsColaboradores = [];

  for (let i = 0; i < tradecolaboradores.length; i++) {
    emailsColaboradores.push(tradecolaboradores[i].split('###master')[0]);
    
  }

  var nomeDaPendencia = document.querySelector('.inputNormal').value;
  var prioridadependencia = document.querySelector('.prioridade').value;



  fetch('https://apilumera.shop/api/criarordem', {
    method: 'POST',
    body: JSON.stringify({
      email: firebaseAuth.currentUser.email,
      parametroId: parametroId,
      nomeOrdem: nomeDaPendencia,
      participantes: tradecolaboradores,
      emailsParticipantes: emailsColaboradores,
      prioridade: prioridadependencia,
      nomeProjeto: nomeproj
    //  ordemPrioridade: ordemPrioridade
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {
        navigate(-1);
     })
     .catch((err) => {
      navigate(-1);
     });



}


function setSearchNome(params) {
  let parlenght = params.length;
  console.log('LENGHT', parlenght, 'PARAMS', params);
  setFiltrados(dataA.filter(element => {
      if(params.length < 1){
        return dataA;
      } else {
        return element.nomeDoProjeto.toLowerCase().slice(0, parlenght) == params.toLowerCase().slice(0, parlenght);
      }


}))
}










function filtrarSelecao(param) {
  console.log(param)
var tradeobj = [];

for (let i = 0; i < dataA.length; i++) {
  if(dataA[i].nomeDoProjeto == param) {
    tradeobj.push(dataA[i]);
  }
}
    setFiltrados(tradeobj);
    console.log(tradeobj.nomeDoProjeto);

}








function filtrar(params) {
// console.log(params);

var tradeobj3 = [];

if(document.querySelectorAll('.checkb')[0].checked){
for (let i = 0; i < dataA.length; i++) {
  if(dataA[i].andamento == true) {
    tradeobj3.push(dataA[i]);
  }
}
}

if(document.querySelectorAll('.checkb')[1].checked){
for (let i = 0; i < dataA.length; i++) {
  if(dataA[i].andamento == false) {
    tradeobj3.push(dataA[i]);
  }
}
}

var count = [];

for (let i = 0; i < document.querySelectorAll('.checkpoint input').length; i++) {
  count.push(document.querySelectorAll('.checkpoint a')[i].innerText);  
}

count.map((data, index)=> {
  
  
if(document.querySelectorAll('.checkpoint input')[index].checked){
  for (let i = 0; i < dataA.length; i++) {
    if(dataA[i].colaboradores[0] != undefined && dataA[i].colaboradores.length > 0) {

   if(dataA[i].colaboradores[0].split('###master')[3].replaceAll(' ', '') == 
    data.replaceAll(' ', '')) {
    tradeobj3.push(dataA[i]);

  }
    }
  
  }
}




})










var count2 = [];

for (let i = 0; i < document.querySelectorAll('.checkpoint2 input').length; i++) {
  count2.push(document.querySelectorAll('.checkpoint2 a')[i].innerText);  
}

count2.map((data, index)=> {
  
  
if(document.querySelectorAll('.checkpoint2 input')[index].checked){
  for (let i = 0; i < dataA.length; i++) {
    if(dataA[i].colaboradores[0] != undefined && dataA[i].colaboradores.length > 0) {

   if(dataA[i].colaboradores[0].split('###master')[1].replaceAll(' ', '') == 
    data.replaceAll(' ', '')) {
    tradeobj3.push(dataA[i]);

  }
    }
  
  }
}




})
















    setFiltrados(tradeobj3);




}











var trad = [];

function mapear() {
            
  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
      
  }
  trad.push(countMp);
  setMapeA(trad);
}







    return (


<>


        <div>


<HomeLf/>



<div className="fixmargin"></div>



      <div  style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: '100%', position: 'absolute',
 display: hide2 ,justifyContent: 'center', alignItems: 'center', zIndex: '900'

}}>


<div style={{ width: '500px',borderRadius: '16px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div>    <i class="bi bi-x" style={{fontSize: '25px', cursor: 'pointer'}}
onClick={()=> setHide2('none')}
/>
</div>

</div>
<div>






 <div
      style={{
     
        height: "100%",
        width: "100%",
        borderRadius: 10
      }}
    >
    
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        Filtros{" "}
        <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69", cursor: 'pointer' }}
        onClick={()=> {limparFiltros(); setHide2('none')}}
        >
          Limpar Tudo
        </a>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Status</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>
        <div
          style={{
            marginTop: 15,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            onClick={()=> filtrar()}
            className="checkb"
          />{" "}
          <a>Pendente</a>
        </div>
        <div
          style={{
            marginTop: 5,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            className="checkb"
            onChange={()=> filtrar()}
          />{" "}
          <a>Concluído</a>
        </div>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Responsável pela Solução</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>




 {solucao.map((data, index)=> {

          return <>
                  <div
          style={{
            marginTop: '8px',
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <div className="checkpoint">
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            
            onChange={()=> filtrar()}
          />{" "}
          <a>{
              data[0].split('#master')[3]
          }</a>
          </div>
        </div>
          
          
          </>
        })}







      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Requisitante</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>






 {solucao.map((data, index)=> {

          return <>
                  <div
          style={{
            marginTop: '8px',
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <div className="checkpoint2">
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            
            onChange={()=> filtrar()}
          />{" "}
          <a>{
              data[0].split('#master')[1].replaceAll('##', '')
          }</a>
          </div>
        </div>
          
          
          </>
        })}








      </div>
    </div>







<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div
         style={{width: '120px', cursor: 'pointer', height: '35px', borderRadius: '10px',
           display: 'flex', justifyContent: 'center',
            alignItems: 'center', fontWeight: '600', color: '#fff', backgroundColor: '#985EAC'}}
          onClick={()=> setHide2('none')}
        >Aplicar</div>
</div>

</div>



























<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>



















    
<div
  className="col-12"
  style={{
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    marginTop: 50,
    paddingRight: 20
  }}
>
  <div className="col-3 responsivefiltro" style={{ padding: "0px 20px" }}>
    <div
      style={{
        border: "1px solid #DEE1E6",
        height: "100%",
        width: "100%",
        borderRadius: 10
      }}
    >
 
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        Filtros{" "}
        <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
          Limpar Tudo
        </a>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Status</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>
        <div
          style={{
            marginTop: 15,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
             onChange={()=> filtrar()}
             className='checkb'
          />{" "}
          <a>Pendente</a>
        </div>
        <div
          style={{
            marginTop: 5,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            onChange={()=> filtrar()}
            className='checkb'
          />{" "}
          <a>Concluído</a>
        </div>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between",
          marginBottom: '15px'
         }}>
          <a>Responsável pela Solução</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>

    
        {solucao.map((data, index)=> {

          return <>
                  <div
          style={{
            marginTop: '8px',
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <div className="checkpoint">
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            
            onChange={()=> filtrar()}
          />{" "}
          <a>{
              data[0].split('#master')[3]
          }</a>
          </div>
        </div>
          
          
          </>
        })}

     
       
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Requisitante</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>
    
       {solucao.map((data, index)=> {

          return <>
                  <div
          style={{
            marginTop: '8px',
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <div className="checkpoint2">
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            className="checkpoint2"
            onChange={()=> filtrar()}
          />{" "}
          <a>{
              data[0].split('#master')[1].replaceAll('#', '')
          }</a>
        </div>
          </div>
          
          </>
        })}






      </div>
    </div>
  </div>
  <div className="col-9">
    <div>
      <div style={{display: 'flex'}}>
           <div style={{ marginBottom: 40 }}>
        <h2 className="meusProjetos">Relatório</h2>
      </div>
            <div className="botaofiltros" style={{ justifyContent: 'center', alignItems: 'center', 
          marginLeft: '20px', border: 'rgb(52, 52, 52) solid 1px', height: '40px', padding: '10px 20px',
          borderRadius: '10px', color: 'rgb(52, 52, 52)', cursor: 'pointer'}}
              onClick={()=> setHide2('flex')}
          >Filtros</div>
      </div>
   
    
      <div
        style={{ marginBottom: 50, marginLeft: "-30px" }}
        className="d-flex row wrap flex-row"
      >
 


          <div style={{display: 'flex'}}>
 <div style={{margin: '0px 20px'}}>
    
 <div style={{fontWeight: 'bold', marginBottom: '2px'}}>Pesquisar por nome</div>
<div className="dastasColaboradores" style={{display: 'flex', marginBottom: '12px', flexFlow: 'row wrap', gap: '10px', marginTop: '10px'}}>
<input 
className='inputNormal'
 style={{padding: '5px 5px', borderRadius: '5px', border: 'solid 1px rgb(100, 100, 100)'}}
  placeholder='Nome do projeto'
  onChange={(e)=> setSearchNome(e.target.value)}
  ></input>
</div>

 </div>

 <div style={{margin: '0px 20px'}} className='responsivefiltro'>
    
    <div style={{fontWeight: 'bold', marginBottom: '2px'}}>Selecionar projeto</div>
   <div className="dastasColaboradores" style={{display: 'flex', marginBottom: '12px', flexFlow: 'row wrap', gap: '10px', marginTop: '10px'}}>
   <select style={{height: '35px', borderRadius: '5px', padding: '0px 10px'}}
   onChange={(e) => filtrarSelecao(e.target.value)}
   >
          {dataA.map((data, index) => {
            return ( <>
            
            <option>{data.nomeDoProjeto}</option>
            
            </>)
          })}
 


   </select>
   </div>
   
    </div>
    
 
 </div>



     
      </div>
      <div
        style={{
          display: "flex",
          flexFlow: "row nowrap",
          justifyContent: "space-between"
        }}
      >
        <div
          style={{
            fontFamily: "Archivo, serif",
            fontWeight: "bold",
            fontSize: 24
          }}
        >
          Resultados:
        </div>
    
      </div>








<div className='responsivefiltro'>

{filtrados.map((data, index)=> {

return <>


<div style={{ marginTop: 20 }}>
        {" "}
        {/* COL 12 SISTEM */}
        <div
          style={{
            border: "1px #DEE1E6 solid",
            borderRadius: 12,
            padding: 18,
            height: 168
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: 40
            }}
          >
            <div
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                justifyContent: "center",
                alignContent: "center",
                fontFamily: "Convergence, serif",
                fontSize: 18
              }}

            >
              {data.nomeDoProjeto}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: `${data.andamento ? "#FEF6F1" : "rgb(238, 253, 243)"}`,
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingLeft: 2,
                  paddingRight: 10,
                  marginLeft: 15,
                  color: `${data.andamento ? "#AE530D" : "#117B34"}`
                }}
              >
                <i
                  className="bi bi-arrow-right-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>{data.andamento ? 'Em andamento' : 'Concluído'} </a>
              </div>{" "}
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  fontFamily: "Inter, serif",
                  fontSize: 12
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexFlow: "column",
                    justifyContent: "center"
                  }}
                >
                  {" "}
                  Status:
                </div>{" "}
                <div
                  className="red"
                  style={{
                    height: 24,
                    backgroundColor: `${data.andamento ? "#FEF6F1" : "rgb(238, 253, 243)"}`,
                    borderRadius: 14,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: '0px 10px',
                    paddingRight: 5,
                    marginLeft: 5
                  }}
                >
                  <a style={{ paddingBottom: 2, color: `${data.andamento ? "#AE530D" : "#117B34"}` }}>
                    {data.andamento ? 'Em andamento' : 'Concluído'} {" "}
                  </a>
                </div>{" "}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              marginTop: 10
            }}
          >
            <div
              style={{
                height: 70,
                display: "flex",
                flexFlow: "column",
                textAlign: "center",
                justifyContent: "center",
                backgroundColor: "#F8F9FA",
                borderRadius: 6,
                padding: "0px 45px"
              }}
            >
              <a
                style={{
                  fontFamily: "Inter, serif",
                  fontSize: 14,
                  fontWeight: "bold"
                }}
              >
                 {Object.keys(data.ordens).length}
               
              </a>
              <a style={{ fontFamily: "Inter, serif", fontSize: 12 }}>
                Pendências
              </a>
            </div>
            <div
              style={{
                height: 70,
                display: "flex",
                flexFlow: "column",
                textAlign: "center",
                justifyContent: "center",
                backgroundColor: "#F8F9FA",
                borderRadius: 6,
                padding: "0px 45px"
              }}
            >
              <a
                style={{
                  fontFamily: "Inter, serif",
                  fontSize: 14,
                  fontWeight: "bold"
                }}
              >
               {data.colaboradores.map((data, index)=> {
                  return <>
                  {data.split('###master')[3]} /
                  </>
                })}
              </a>
              <a style={{ fontFamily: "Inter, serif", fontSize: 12 }}>
                Responsáveis pela Solução
              </a>
            </div>
            <div
              style={{
                height: 70,
                display: "flex",
                flexFlow: "column",
                textAlign: "center",
                justifyContent: "center",
                backgroundColor: "#F8F9FA",
                borderRadius: 6,
                padding: "0px 45px"
              }}
            >
              <a
                style={{
                  fontFamily: "Inter, serif",
                  fontSize: 14,
                  fontWeight: "bold"
                }}
              >
                {data.dataDeCriacao.slice(8,10)+'/'+data.dataDeCriacao.slice(5,7)+'/'+data.dataDeCriacao.slice(0,4) }
              </a>
              <a style={{ fontFamily: "Inter, serif", fontSize: 12 }}>
                Data de Criação
              </a>
            </div>
            <div
              style={{
                width: 154,
                height: 36,
                backgroundColor: "#574A69",
                borderRadius: 10,
                fontFamily: "inter, serif",
                fontSize: 14,
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: 'pointer'
              }}
         
              onClick={()=> navigate(`/relatoriomain?prjid=${data.idProjeto}`)}
            >
              <a style={{ fontSize: 14, fontWeight: 200, marginRight: 4 }}>
                <i className="bi bi-search" />{" "}
              </a>{" "}
              Ver Relatório
            </div>
       
          </div>
        </div>
      </div>




</>

})}


</div>





<div className='botaofiltros'>


<div
  className="d-flex row wrap flex-row gap-3"
  style={{ justifyContent: "flex-start", marginTop: 20 }}
>
  {filtrados.map((data, index) => {
    return <>
    
      <div
    className="col-4"
    style={{
      border: "1px solid #DEE1E6",
      borderRadius: 10,
      paddingLeft: 20,
      width: 281
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        paddingRight: 12,
        paddingTop: 10,
        fontFamily: "Inter, serif",
        fontSize: 12,
        color: "#565D6D"
      }}
    >
      {data.dataDeCriacao.slice(8,10)+'/'+data.dataDeCriacao.slice(5,7)+'/'+data.dataDeCriacao.slice(0,4) }
    </div>
    <div
      style={{
        fontFamily: "Convergence, serif",
        fontSize: 18,
        color: "#171A1F",
        marginTop: 10
      }}
    >
      {data.nomeDoProjeto}  
    </div>
    <div style={{ display: "flex", flexFlow: "column", marginTop: 15 }}>
      <a style={{ fontFamily: "Inter, serif", fontSize: 11 }}>Pendências</a>
      <a
        style={{ fontFamily: "Inter, serif", fontSize: 14, fontWeight: "bold" }}
      >
        {Object.keys(data.ordens).length}
      </a>
    </div>
    <div style={{ display: "flex", flexFlow: "column", marginTop: 15 }}>
      <a style={{ fontFamily: "Inter, serif", fontSize: 11 }}>
        Responsáveis pela solução:
      </a>
      <a
        style={{ fontFamily: "Inter, serif", fontSize: 14, fontWeight: "bold" }}
      >
         {data.colaboradores.map((data, index)=> {
                  return <>
                  {data.split('###master')[3]} /
                  </>
                })}
      </a>
    </div>




  <div style={{ display: "flex", marginTop: 15 }}>
      <div
        className="red"
        style={{
          height: 28,
          backgroundColor: `${data.andamento == false ? "#EEFDF3" : "#FEF9EE"}`,
          borderRadius: 14,
          display: "flex",
          color: `${data.andamento == false ? "#117B34" : "#98690C"}`,
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: 10,
          paddingRight: 10,
          fontSize: 13
        }}
      >
        <a style={{ paddingBottom: 2 }}>{data.andamento == false ? "Finalizado" : "Pendente"} </a>
      </div>
  



  











    </div>









    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: 26,
        marginBottom: 26
      }}
    >
      <div
        style={{
          width: 112,
          height: 32,
          backgroundColor: "#574A69",
          borderRadius: 10,
          fontFamily: "inter, serif",
          fontSize: 12,
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: 'pointer'
        }}
        onClick={()=> navigate(`/relatoriomain?prjid=${data.idProjeto}`)}
      >
        Ver Relatório
      </div>
 
    </div>
  </div>
    
    </>
  })}

</div>

</div>









    </div>
  </div>
</div>







        </div>


<Rodape/>

</>



    )
}
export default Relatorio;